import ToolCallIndicator from "./ToolCallIndicator";

interface DiagnosticToolResultProps {
  tool: string;
  summary: string;
}

/**
 * Renders a filed-issue / escalated-to-developer chip for file_bug_report and
 * escalate_to_developer tool results (which carry "#123 https://...") in their
 * summary), falling back to the regular ToolCallIndicator for everything else.
 */
const DiagnosticToolResult = ({ tool, summary }: DiagnosticToolResultProps) => {
  const isIssueResult = summary.startsWith("#") && summary.includes("http");
  const toolLower = tool.toLowerCase();
  const isBugFiled = toolLower.includes("filing bug report") && isIssueResult;
  const isEscalated = toolLower.includes("escalating to developer") && isIssueResult;
  const issueUrl = isIssueResult ? summary.split(" ").find((p) => p.startsWith("http")) : undefined;
  const issueRef = isIssueResult ? summary.split(" ")[0] : undefined;

  if (isBugFiled) {
    return (
      <a
        href={issueUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-1 inline-flex items-center gap-1.5 rounded-full bg-green-50 px-3 py-1 text-xs font-medium text-green-700 ring-1 ring-green-200 hover:bg-green-100"
      >
        Issue filed — {issueRef}
      </a>
    );
  }

  if (isEscalated) {
    return (
      <a
        href={issueUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-1 inline-flex items-center gap-1.5 rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-200 hover:bg-blue-100"
      >
        Escalated to developer — {issueRef}
      </a>
    );
  }

  return <ToolCallIndicator tool={tool} summary={summary} />;
};

export default DiagnosticToolResult;
